/*维修部位*/

export function getAll(data) {
    return abp.ajax({
        url: '/api/services/app/RepairPosition/GetAllList',
        method: 'get',
        params: data
    });
}

/*新增维修部位*/
export function createPosition(data) {
    return abp.ajax({
        url: '/api/services/app/RepairPosition/CreateAsync',
        method: 'post',
        data: data
    });
}

/*删除维修部位*/
export function deletePosition(id) {
    return abp.ajax({
        url: '/api/services/app/RepairPosition/DeleteAsync',
        method: 'delete',
        params: { id: id }
    });
}

/*维修部位-施工单位 关联表*/
export function getPositionCompanyList(positionId) {
    return abp.ajax({
        url: '/api/services/app/RepairPosition/GetPositionCompanyList',
        method: 'get',
        params: { positionId: positionId }
    });
}

/*新增-维修部分关联施工单位*/
export function createPositionCompany(data) {
    return abp.ajax({
        url: '/api/services/app/RepairPosition/CreatePositionCompany',
        method: 'post',
        data: data
    });
}

/*删除维修部位-施工单位关联*/
export function deletePositionCompany(id) {
    return abp.ajax({
        url: '/api/services/app/RepairPosition/DeletePositionCompany',
        method: 'delete',
        params: { id: id }
    });
}



